import PropTypes from 'prop-types'
import React from 'react'
import UIDropArea from 'components/shared/UIDropArea'
import { PremiumGate } from 'components/payments/Gates'
import { IconPickerConfig } from 'components/Customize/Styling/IconPicker/Constants'
import GatedIconPicker from 'components/Customize/Styling/GatedIconPicker'
import './style.styl'

const customIconPickerFeatureText = "Custom Widget Images"
const customIconPlan = "Standard"

const CustomIconPicker = ({ onDrop, onClear, preview, iconStyle }) => (
  <PremiumGate
    FallbackComponent={<GatedIconPicker iconStyle={iconStyle} />}
    useModal
    modalText={customIconPickerFeatureText}
    modalPlan={customIconPlan}
    feature="widget-custom-icon"
  >
    <UIDropArea onDrop={onDrop} onClear={onClear} preview={preview}>
      <div className="CustomIconPicker">
        <div>Want to add your own image?</div>
        <div>Drag and Drop or <span className="link">Upload</span></div>
      </div>
    </UIDropArea>
  </PremiumGate>
)

CustomIconPicker.propTypes = {
  onDrop: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  preview: PropTypes.string,
}

export default CustomIconPicker



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/CustomIconPicker/index.js